var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.236 57.1429V53.3334C55.236 51.3127 54.4332 49.3747 53.0044 47.9459C51.5755 46.517 49.6376 45.7143 47.6169 45.7143H32.3788C30.3581 45.7143 28.4202 46.517 26.9913 47.9459C25.5625 49.3747 24.7598 51.3127 24.7598 53.3334V57.1429M47.6169 30.4762C47.6169 34.6841 44.2057 38.0953 39.9979 38.0953C35.79 38.0953 32.3788 34.6841 32.3788 30.4762C32.3788 26.2683 35.79 22.8572 39.9979 22.8572C44.2057 22.8572 47.6169 26.2683 47.6169 30.4762Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2e948c0668e1ef86a74a2c43dc9fbfa9.svg";
export { ForwardRef as ReactComponent };